import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect, createContext, useContext, useState } from 'react';
import handleRedirect from './redirectHandler';
import Home from './Home';
import Dealspage from './Dealspage';
import FAQPage from './FAQPage';
import PrivacyPage from './PrivacyPage';
import TermsPage from './TermsPage';
import ContactPage from './ContactPage';
import Cookies from './Cookies';
import Navbar from './Navbar';
import Footer from './Footer';
import { SITE_CONFIG } from './config';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

function ThemeProvider({ children }) {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved ? JSON.parse(saved) : true;
  });

  const theme = isDarkMode ? SITE_CONFIG.theme.dark : SITE_CONFIG.theme.light;

  const toggleTheme = () => {
    setIsDarkMode(prev => {
      const newValue = !prev;
      localStorage.setItem('darkMode', JSON.stringify(newValue));
      return newValue;
    });
  };

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDarkMode);
  }, [isDarkMode]);

  return (
    <ThemeContext.Provider value={{ isDarkMode, theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

function App() {
  useEffect(() => {
    handleRedirect();
  }, []);

  return (
    <ThemeProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </ThemeProvider>
  );
}

function AppContent() {
  const { theme } = useTheme();

  return (
    <div className={`flex flex-col min-h-screen bg-gradient-to-br ${theme.primary.bg} ${theme.primary.text}`}>
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/deals" element={<Dealspage />} />
          <Route path="/deals/:retailer" element={<Dealspage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/cookies" element={<Cookies />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;